<template>
  <v-container class="cmp-royalty-statement-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <div class="dt-details2">
        <div class="dt-details--header">
          <div
            class="title"
            :title="
              selectedStatementDetails &&
              selectedStatementDetails.statement.royalty_account_name &&
              selectedStatementDetails.statement.royalty_account_name
            "
          >
            <span>{{ sideHeader || "Statement" }}</span>
          </div>
          <br />
        </div>
      </div>
      <glayout
        :tabs="[
          {
            route: 'overview',
            value: $t('overview'), // Tab Name
          },
        ]"
        :showTabs="false"
        :loading="selectedStatementDetails && selectedStatementDetails.loading"
      >
        <gtab id="overview">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedStatementDetails &&
                      selectedStatementDetails.contracts &&
                      selectedStatementDetails.contracts.length,
                    offset: NTOffsets.WithHeader,
                    rowHeight: 48,
                    min: 1,
                    max: 10,
                  })
                "
                :title="''"
              >
                <StatementContract
                  :selectedStatementDetails="selectedStatementDetails"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox :title="$t('send_log')">
                <SendLog
                  :selectedStatementDetails="selectedStatementDetails"
                  @emptyLog="emptyLog"
                />
              </gbox>
              <gbox :title="$t('notes')" bc="var(--bc-note)">
                <DBoxTextarea
                  :value="selectedStatementDetails.statement.notes"
                  :id="'notes'"
                  @blur="
                    (e) =>
                      onUpdated({
                        name: 'notes',
                        value: e.target.value,
                      })
                  "
                />
              </gbox>
            </gcol>
            <gcol>
              <div style="margin-top: 16px; margin-bottom: 0px">
                <StatementSummary
                  :selectedStatementDetails="selectedStatementDetails"
                  @updateTaxDeduction="onUpdateTaxDeduction"
                  @updateVatRate="onUpdateVatRate"
                  @onSendEmail="sendEmail"
                  @onShowStatment="showStatment"
                  @onChangeClosing="onChangeClosing"
                  @onCreateCredit="onCreateCredit"
                />
              </div>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox :h="98" :title="$t('payment')" v-if="singlePaymentExists">
                <Payment
                  :selectedStatementDetails="selectedStatementDetails"
                  @editClicked="onEditClicked"
                  @deleteClicked="onDeletePayment"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>
    <ModalContainer :modalKey="'editRoyaltyStatement'" :width="'small'">
      <EditRoyaltyStatement
        :selectedRpPayment="selectedRpPayment"
        @cancelled="onDialogCancelled"
        @edited="onEditRPModalData"
      />
    </ModalContainer>
  </v-container>
</template>

<script>
import * as ActionTypes from "../../store/types";
import BoxWidget from "@plugins/box-widget/box-widget";

import {
  createModalMixin,
  openModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";

import { mapGetterObject, mapActionObject } from "../../../../store/global";

import { JSONX, sendMail } from "../../../../utility";
import { MHTTPCL } from "../../../../services/http/http-client";
import { statementsListLDTRoutes } from "../../router/routes";

import { RoyaltyStoreNamespace as storeNS } from "../../store";
import { format } from "date-fns";
import { statementGetters } from "../../store/statement/getters";
import { statementActions } from "../../store/statement/actions";
import StatementContract from "./statement-contract.vue";
import SendLog from "./send-log";
import Payments from "./payments.vue";
import Payment from "./payment.vue";
import DBoxTextarea from "@dtplugins/dbox-textarea/dbox-textarea";
import StatementSummary from "./statement-summary";
import { statementServices } from "../../services/statements/statements.service";
import { costListLDTRoutes } from "../../../accounting/router/routes";
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import EditRoyaltyStatement from "../accounts/edit-royalty-statement.vue";
import ModalContainer from "@dtplugins/modal/modal-container";
import { AccountsService } from "../../services/accounts.service";
import { confirmDelete } from '../../../../dt-plugins/confirmation/confirmation-common';

//import { LABEL_URL } from '../../../../services/common-urls';
//import { baseUrl, clientId } from '../../../b2b/services/http-client';
export const moduleRoute = "royalty";
export const submenuRoute = "statements";

export default {
  components: {
    BoxWidget,
    DBoxTextarea,
    ModalContainer,
    StatementContract,
    SendLog,
    StatementSummary,
    Payments,
    Payment,
    EditRoyaltyStatement,
  },
  props: {},
  mounted: () => {
    // console.log("WEREEERRRR", this.selectedStatementDetails);
  },
  data: () => ({
    active: -1,

    lockLoading: false,
    formatDate: format(new Date(), "YYYY-MM-DD HH:MM:SS"),

    selectedRpPayment: {},
  }),
  mixins: [
    createDTGridHost(),
    createModalMixin("addRelatedProduct"),
    createModalMixin("addLink"),
    createModalMixin("documentModal"),
    createModalMixin("addGenre"),
    createModalMixin("addManualMatch"),
    createModalMixin("addArtist"),
    createModalMixin("editRoyaltyStatement"),
  ],

  computed: {
    ...mapGetterObject(storeNS, statementGetters),
    statementSidewindowTabs: function () {
      return [
        {
          route: "overview",
          value: this.$t("overview"), // Tab Name
        },
      ];
    },

    royalty_period_id: function () {
      return this.$route.params.royalty_period_id;
    },

    selectedStatementDetails: function () {
      const statementDetails =
        (this.statementDetails || {})[this.royalty_period_id] || {};
      // let statement =
      //   this.statementList?.statements.find(
      //     (s) => s.royalty_period_id == this.royalty_period_id
      //   ) || {};
      // console.log("...statement", { ...statement });
      const invoice = statementDetails.response?.invoice || {};
      const response = statementDetails.response || { invoice };

      const royaltyRef = response?.invoice_project?.royalty_ref || "";
      const contracts =
        statementDetails.response?.statement_info?.contracts || [];
      let statement = statementDetails?.response?.rp || {};
      const ra = statementDetails.response?.ra || {};
      statement = {
        ...statement,
        royalty_account_name: ra?.royalty_account_name,
      };
      console.log("...statement", { ...statement });
      console.log("...statementDetails", { ...statementDetails });
      return {
        ...statementDetails,
        statement,
        response,
        royaltyRef,
        contracts,
      };
    },

    sideHeader: function () {
      const statementDetails =
        (this.statementDetails || {})[this.royalty_period_id] || {};
      const ra = statementDetails.response?.ra || {};
      const statement =
        {
          ...statementDetails?.response?.rp,
          royalty_account_name: ra?.royalty_account_name,
        } || {};

      const name = statement?.royalty_account_name || "";
      const dateRange = `${statement?.start_date || ""} - ${
        statement?.end_date || ""
      }`;

      return `${name} - ${dateRange}`;
    },
    singlePaymentParsed: function () {
      return JSONX.tryParse(
        this.selectedStatementDetails?.response?.rp?.json_data
      );
    },
    singlePaymentExists() {
      return this.singlePaymentParsed.success;
    },
    singlePaymentInfo() {
      return this.singlePaymentParsed.result;
    },

    // MARK: Computed
  },
  methods: {
    ...mapActionObject(storeNS, statementActions),

    onUpdated: function (payload) {
      payload.item = this.selectedStatementDetails;
      this[ActionTypes.StatementDetails.UPDATE.SINGLE](payload);
    },

    sendEmail: async function () {
      const payload = {
        kVal: this.selectedStatementDetails.statement.royalty_period_id,
        name: "lock_flag",
        value: 1,
      };
      await this[ActionTypes.StatementList.UPDATE.SINGLE](payload);

      console.log(
        "this.selectedStatementDetails.statement",
        this.selectedStatementDetails.statement
      );

      const body =
        "url:" +
        this.selectedStatementDetails.statement.stmt_link +
        "\n shared-key: " +
        this.selectedStatementDetails.statement.shared_key;

      const subject =
        "Royalty Statement " +
        this.selectedStatementDetails.statement.royalty_account_name;

      const mails = [this.selectedStatementDetails.statement.email1];

      console.log("subject,body,recepient", subject, body, mails);
      sendMail({ subject, body, mails });
    },

    showStatment: function () {
      // const url=`${MHTTPCL.baseUrl}/label/${MHTTPCL.clientName}/royalty_period_id=${this.selectedStatementDetails.statement.royalty_period_id}&section=royalty&action=royalty_period_statement_export&royalty_period_key=${this.selectedStatementDetails.response.rp.royalty_period_key}`
      console.log(":::", this.selectedStatementDetails.statement.stmt_link);
      window.open(this.selectedStatementDetails.statement.stmt_link, "_blank");
    },

    emptyLog: function () {
      this[ActionTypes.Log.DELETE.ALL]({ item: this.selectedStatementDetails });
    },

    onUpdateTaxDeduction: function (payload) {
      this[ActionTypes.TaxDeduction.UPDATE.SINGLE]({
        item: this.selectedStatementDetails,
        value: payload,
      });
    },

    onUpdateVatRate: function (payload) {
      this[ActionTypes.RoyaltyStatementVatRate.UPDATE.SINGLE]({
        item: this.selectedStatementDetails,
        value: payload,
      });
    },

    onChangeClosing: function () {
      this[ActionTypes.ClOSING_STATEMENT]({
        selectedStatementDetails: this.selectedStatementDetails,
      });
    },

    onCreateCredit: async function () {
      const resData = await statementServices.createInvoice(
        this.selectedStatementDetails?.statement?.royalty_period_id,
        ""
      );

      console.log("resData", resData);

      this.$router.push({
        name: costListLDTRoutes.names.tab,
        params: {
          invoice_id: resData.data.invoice.invoice_id,
          tab: "overview",
        },
      });
    },
    onEditRPModalData({ json_data, royalty_period_id }) {
      this.onDialogCancelled();

      console.log("json_data", json_data);
      this[ActionTypes.StatementPayment.SET.ALL]({
        json_data,
        royalty_period_id,
      });
    },
    onEditClicked() {
      this.selectedRpPayment = {
        ...this.selectedStatementDetails?.response?.rp,
      };
      openModalRoute(this, "edit_royalty_statement", {
        mode: "add",
        royalty_period_id:
          this.selectedStatementDetails?.response?.rp?.royalty_period_id,
      });
    },
    async onDeletePayment() {
      const royalty_period_id = this.selectedStatementDetails?.response?.rp?.royalty_period_id;
      
      const confirmationResult = await confirmDelete(
        this.$t("payment"),
        this.singlePaymentInfo?.payment_reference
      );
      if (confirmationResult === "OK") {
        this[ActionTypes.StatementPayment.SET.ALL]({
          json_data: null,
          royalty_period_id,
        });

        await AccountsService.saveRPpaymentdata({
          rpModelData: null,
          royalty_period_id: this.royalty_period_id,
        });
      }
    },
    onDialogCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    //MARK: Methods
  },
};
</script>
<style lang="scss">
.cmp-royalty-statement-sidewindow {
  .dt-grid-layout {
    // height: calc(100vh - 120px);
    height: calc(100vh - 77px);
    // .dt-box-header{
    //   background-color: rgb(247, 255, 242);
    // }
  }
}
</style>
